import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { whatsappLink, telLink, BRAND } from "@/lib/data";

// Solid dark button (primary)
export const WhatsAppButton = ({
  label = "WhatsApp Us",
  message,
  className = "",
  testid = "whatsapp-btn",
}) => (
  <a
    href={whatsappLink(message)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-sm bg-ink px-7 py-3.5 text-[0.78rem] font-semibold uppercase tracking-[0.14em] text-offwhite transition-colors duration-500 hover:bg-gold hover:text-ink ${className}`}
  >
    <WhatsappLogo weight="fill" size={17} />
    <span>{label}</span>
  </a>
);

// Outlined button (secondary)
export const CallButton = ({
  label = `Call ${BRAND.phoneDisplay}`,
  className = "",
  testid = "call-btn",
}) => (
  <a
    href={telLink()}
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-sm border border-ink bg-transparent px-7 py-3.5 text-[0.78rem] font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-500 hover:bg-ink hover:text-offwhite ${className}`}
  >
    <Phone weight="fill" size={16} />
    <span>{label}</span>
  </a>
);
